import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubBrowseAllCategoriesRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-browse-all-categories',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/categories',
	exact: true,
};
